import mapManagement from '@Apis/mapManagement.api';
import assetManagement from '@Apis/assets.api';
import inspectionManagement from '@Apis/inspectionManagement.api';

export const getThemeList = () =>
	mapManagement.get('/v2/themes?appId=appInfo360');

export const regenerateAssetTiles = () =>
	assetManagement.get('/v2/tileset/generate');

export const regenerateSensorTiles = () =>
	assetManagement.get('/v2/tileset/generate?systemType=Sensors');

export const regenerateInspectionTiles = () =>
	inspectionManagement.get('/tileset/generate');
